import React, { useState, useMemo, useEffect, useRef } from 'react'

function formatDate(d){ return d.toLocaleString(); }

function usePersistedArray(key, length){
  const [arr, setArr] = useState(()=>{
    try{
      const raw = localStorage.getItem(key);
      if(raw){
        const parsed = JSON.parse(raw);
        if(Array.isArray(parsed)){
          const out = Array(length).fill('pending');
          for(let i=0;i<Math.min(parsed.length, length); i++){
            const v = parsed[i]; if(v==='doneOnTime' || v==='doneLate') out[i]=v;
          }
          return out;
        }
      }
    }catch(e){}
    return Array(length).fill('pending');
  });

  useEffect(()=>{ try{ localStorage.setItem(key, JSON.stringify(arr)); }catch(e){} }, [key, arr]);
  return [arr, setArr];
}

function DebugLocalStoragePanel(){
  const [items, setItems] = useState([]);
  useEffect(()=>{
    const read = ()=>{
      try{
        const out = [];
        for(let i=0;i<localStorage.length;i++){
          const k = localStorage.key(i); if(!k) continue;
          if(k.startsWith('followups-rajesh') || k.startsWith('meds-rajesh')){
            try{ out.push({key:k, val: JSON.parse(localStorage.getItem(k) || 'null')}); }catch(e){ out.push({key:k, val: localStorage.getItem(k)}); }
          }
        }
        setItems(out);
      }catch(e){ setItems([]); }
    }
    read(); const id = setInterval(read, 2000); return ()=>clearInterval(id);
  }, []);

  return (
    <div className="mb-4 p-3 bg-gray-50 border border-gray-200 rounded">
      <div className="font-medium mb-2">Debug — localStorage (followups/meds)</div>
      {items.length===0 && <div className="text-sm text-gray-500">No followups/meds entries found in localStorage.</div>}
      {items.map(it=> (
        <div key={it.key} className="text-sm mb-2">
          <div className="font-semibold">{it.key}</div>
          <pre className="text-xs bg-white p-2 rounded border mt-1 overflow-auto">{JSON.stringify(it.val, null, 2)}</pre>
        </div>
      ))}
    </div>
  )
}

function OintmentFollowUps(){
  const reminders = useMemo(()=>{
    const now = new Date(); const list = []; const start = new Date(); start.setHours(21,0,0,0);
    if(now > start) start.setDate(start.getDate()+1);
    for(let i=0;i<7;i++){ const d = new Date(start); d.setDate(start.getDate()+i); list.push(d); }
    return list;
  }, []);

  const storageKey = useMemo(()=>{ try{ return 'followups-rajesh-' + reminders[0].toISOString().slice(0,10) }catch(e){ return 'followups-rajesh' } }, [reminders]);
  const [statuses, setStatuses] = usePersistedArray(storageKey, reminders.length);

  const clearAll = ()=>{ const empty = Array(reminders.length).fill('pending'); setStatuses(empty); try{ localStorage.removeItem(storageKey) }catch(e){} }
  const toggle = (idx)=>{ const now = new Date(); const r = reminders[idx]; const windowStart = new Date(r); const windowEnd = new Date(r); windowEnd.setDate(r.getDate()+1); windowEnd.setHours(0,0,0,0); setStatuses(prev=>{ const next = prev.slice(); const cur = next[idx]; if(cur==='pending'){ if(now>=windowStart && now<windowEnd) next[idx]='doneOnTime'; else next[idx]='doneLate'; } else next[idx]='pending'; return next; }); }

  return (
    <div>
      <h3 className="text-lg font-semibold mb-3">Ointment — nightly</h3>
      <div className="mb-4 text-gray-600">Regimen: apply ointment nightly. Scheduled reminders at 9:00 PM for 7 days.</div>
      <button onClick={clearAll} className="mb-3 px-3 py-1 border rounded text-sm text-gray-700 hover:bg-gray-100">Clear</button>
      <ul className="space-y-2">
        {reminders.map((r, idx)=>{
          const status = statuses[idx]; const now = new Date(); const windowEnd = new Date(r); windowEnd.setDate(r.getDate()+1); windowEnd.setHours(0,0,0,0);
          const isDoneOnTime = status==='doneOnTime'; const isDoneLate = status==='doneLate'; const overdue = status==='pending' && now.getTime() >= windowEnd.getTime();
          let cardClass = 'bg-white border border-gray-100 p-4 rounded-2xl shadow-sm';
          if(isDoneOnTime) cardClass = 'bg-gradient-to-r from-green-50 to-white border-green-200 p-4 rounded-2xl shadow-sm';
          else if(isDoneLate||overdue) cardClass = 'bg-gradient-to-r from-red-50 to-white border-red-200 p-4 rounded-2xl shadow-sm';

          const btnClass = isDoneOnTime ? 'bg-green-600 text-white px-3 py-1 rounded-md text-sm' : (isDoneLate||overdue) ? 'bg-red-600 text-white px-3 py-1 rounded-md text-sm' : 'px-3 py-1 border rounded-md text-sm';
          const statusPill = isDoneOnTime ? <span className="inline-flex items-center gap-2 px-2 py-1 rounded-md text-xs font-medium bg-green-100 text-green-800">Taken</span> : (isDoneLate ? <span className="inline-flex items-center gap-2 px-2 py-1 rounded-md text-xs font-medium bg-red-100 text-red-800">Taken (late)</span> : (overdue ? <span className="inline-flex items-center gap-2 px-2 py-1 rounded-md text-xs font-medium bg-red-50 text-red-700">Overdue</span> : <span className="inline-flex items-center gap-2 px-2 py-1 rounded-md text-xs text-gray-700 bg-gray-50">Pending</span>));

          return (
            <li key={idx} className={cardClass}>
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-soft text-sm font-medium text-gray-700">R{idx+1}</div>
                  <div>
                    <div className="font-semibold">{formatDate(r)}</div>
                    <div className="text-sm text-gray-500">Apply ointment nightly</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div>{statusPill}</div>
                  <button onClick={()=>toggle(idx)} className={btnClass}>{isDoneOnTime ? 'Undo' : 'Mark done'}</button>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export function TwiceDailyMedicationReminders({ patient = 'rajesh' }){
  const reminders = useMemo(()=>{
    const now = new Date(); const list = []; const start = new Date(); start.setHours(10,0,0,0); if(now > start) start.setDate(start.getDate()+1);
    for(let i=0;i<7;i++){ const day = new Date(start); day.setDate(start.getDate()+i); const m = new Date(day); m.setHours(10,0,0,0); const n = new Date(day); n.setHours(21,0,0,0); list.push(m,n); }
    return list;
  }, []);

  const storageKey = useMemo(()=>{ try{ return `meds-${patient}-twice-daily-` + reminders[0].toISOString().slice(0,10) }catch(e){ return `meds-${patient}-twice-daily` } }, [reminders, patient]);
  const [statuses, setStatuses] = usePersistedArray(storageKey, reminders.length);

  useEffect(()=>{ try{ if(typeof window !== 'undefined'){ const p = new URLSearchParams(window.location.search); if(p.get('autotest') === 'markMed1'){ const next = Array(reminders.length).fill('pending'); if(next.length>0) next[0]='doneOnTime'; if(next.length>1) next[1]='doneOnTime'; setStatuses(next); try{ localStorage.setItem(storageKey, JSON.stringify(next)) }catch(e){} try{ const u=new URL(window.location.href); u.searchParams.delete('autotest'); window.history.replaceState({},'',u.toString()); }catch(e){} } } }catch(e){} }, [reminders, storageKey, setStatuses]);

  const clearAll = ()=>{ const empty = Array(reminders.length).fill('pending'); setStatuses(empty); try{ localStorage.removeItem(storageKey) }catch(e){} }
  const toggle = (idx)=>{ const now = new Date(); const r = reminders[idx]; const windowStart = new Date(r); const windowEnd = new Date(r); if(r.getHours() === 10) windowEnd.setHours(12,0,0,0); else { windowEnd.setDate(r.getDate()+1); windowEnd.setHours(0,0,0,0); } setStatuses(prev=>{ const next = prev.slice(); const cur = next[idx]; if(cur==='pending'){ if(now>=windowStart && now<windowEnd) next[idx]='doneOnTime'; else next[idx]='doneLate'; } else next[idx]='pending'; return next; }); }

  // group reminders into days for rendering (pairs: morning index = d*2, night = d*2+1)
  const days = useMemo(()=>{
    const out = [];
    for(let d=0; d<reminders.length/2; d++){
      out.push({ morning: reminders[d*2], night: reminders[d*2+1] });
    }
    return out;
  }, [reminders]);

  return (
    <div>
      <h3 className="text-lg font-semibold mb-3">Medication — 1 tablet (morning & night)</h3>
      <div className="mb-3 text-gray-600">Morning window: 10:00–12:00. Night window: 21:00–00:00. (7 days)</div>
      <button onClick={clearAll} className="mb-3 px-3 py-1 border rounded text-sm text-gray-700 hover:bg-gray-100">Clear</button>
      <ul className="space-y-2">
        {days.map((day, dIdx)=>{
          const mIdx = dIdx*2; const nIdx = dIdx*2+1;
          const m = day.morning; const n = day.night;
          const mStatus = statuses[mIdx]; const nStatus = statuses[nIdx];
          const now = new Date();
          const mWindowEnd = new Date(m); mWindowEnd.setHours(12,0,0,0);
          const nWindowEnd = new Date(n); nWindowEnd.setDate(n.getDate()+1); nWindowEnd.setHours(0,0,0,0);

          const mOnTime = mStatus==='doneOnTime'; const mLate = mStatus==='doneLate'; const mOverdue = mStatus==='pending' && now.getTime() >= mWindowEnd.getTime();
          const nOnTime = nStatus==='doneOnTime'; const nLate = nStatus==='doneLate'; const nOverdue = nStatus==='pending' && now.getTime() >= nWindowEnd.getTime();

          return (
            <li key={dIdx} className="bg-white border border-gray-200 p-3 rounded shadow-sm overflow-hidden">
              <div className="flex items-start justify-between gap-4 flex-col md:flex-row">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <div className="font-semibold">{m.toLocaleDateString()}</div>
                    <div className="text-sm text-gray-600">1 tablet — Morning & Night</div>
                  </div>
                </div>
                <div className="flex gap-3 mt-3 md:mt-0 flex-nowrap">
                  <button onClick={()=>toggle(mIdx)} className={(mOnTime ? 'border-green-300 bg-green-50' : (mLate||mOverdue) ? 'border-red-300 bg-red-50' : 'border-gray-200 bg-white') + ' flex flex-col items-center w-16 shrink-0 p-1 rounded border cursor-pointer'}>
                    <div className={(mOnTime ? 'bg-green-600 text-white' : (mLate||mOverdue) ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-800') + ' flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-semibold'} title={m.toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'})} aria-label={`Morning ${m.toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'})}`}>M</div>
                    <div className="mt-1 w-full text-[10px] text-center text-gray-700">{mOnTime ? 'Taken' : (mLate ? 'Late' : (mOverdue ? 'Overdue' : 'Mark'))}</div>
                  </button>

                  <button onClick={()=>toggle(nIdx)} className={(nOnTime ? 'border-green-300 bg-green-50' : (nLate||nOverdue) ? 'border-red-300 bg-red-50' : 'border-gray-200 bg-white') + ' flex flex-col items-center w-16 shrink-0 p-1 rounded border cursor-pointer'}>
                    <div className={(nOnTime ? 'bg-green-600 text-white' : (nLate||nOverdue) ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-800') + ' flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-semibold'} title={n.toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'})} aria-label={`Night ${n.toLocaleTimeString([], {hour:'2-digit', minute:'2-digit'})}`}>N</div>
                    <div className="mt-1 w-full text-[10px] text-center text-gray-700">{nOnTime ? 'Taken' : (nLate ? 'Late' : (nOverdue ? 'Overdue' : 'Mark'))}</div>
                  </button>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default function FollowUps(){
  const patients = React.useMemo(() => [
    { id: 'rajesh', name: 'Rajesh' },
    { id: 'meera', name: 'Meera' },
    { id: 'priya', name: 'Priya' }
  ], []);

  const [openMap, setOpenMap] = useState(() => ({}));
  const contentRefs = useRef({});

  const toggle = (id)=>{
    setOpenMap(prev=>{
      const next = {...prev, [id]: !prev[id] };
      return next;
    })
  }

  useEffect(()=>{
    // animate open/close by setting maxHeight
    patients.forEach(p=>{
      const el = contentRefs.current[p.id];
      if(!el) return;
      if(openMap[p.id]){
        el.style.maxHeight = el.scrollHeight + 'px';
      }else{
        el.style.maxHeight = '0px';
      }
    })
  }, [openMap, patients]);

  return (
    <section className="py-12">
      <div className="container-custom mx-auto px-6">
        <h2 className="text-3xl font-extrabold mb-6">Follow-ups</h2>
        <div className="space-y-4 max-w-3xl mx-auto">
          {patients.map(p=> (
            <div key={p.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <button onClick={()=>toggle(p.id)} className="w-full text-left p-4 flex items-center justify-between">
                <div>
                  <div className="text-lg font-semibold">{p.name}</div>
                  <div className="text-sm text-gray-500">Click to {openMap[p.id] ? 'hide' : 'view'} follow-ups</div>
                </div>
                <div className="text-gray-400">{openMap[p.id] ? '▲' : '▼'}</div>
              </button>

              <div ref={el=>contentRefs.current[p.id]=el} style={{ maxHeight: 0, transition: 'max-height 300ms ease' }} className="overflow-hidden px-4">
                <div className="py-4 grid gap-6 md:grid-cols-2">
                  <div>
                    <OintmentFollowUps patient={p.id} />
                  </div>
                  <div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <TwiceDailyMedicationReminders patient={p.id} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}